const shipmentProviders = ['euShipments', 'afterSalesPro'];

export default shipmentProviders;
